'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable func-names */
var PopupManagerContext = react.createContext({
    /**
     * Current's open popup close callback function
     */
    currentPopCallback: function () { },
    /**
     * Closes current open popup
     *
     * @example
     * popupCtx.closeCurrent()
     *
     */
    closeCurrent: function () { },
    /**
     * Register the popup executing this function
     *
     * @example
     * popupCtx.register(closePopup)
     *
     */
    register: function (_popupCloseCallback) { },
    /**
     * Unregister the popup executing this function
     *
     * @example
     * popupCtx.unregister()
     *
     */
    unregister: function () { }
});
var PopupManagerContext$1 = PopupManagerContext;

exports.default = PopupManagerContext$1;
//# sourceMappingURL=PopupManagerContext.js.map
